/** Window events shared across the app (kept in their own module to avoid circular imports). */
export const UNAUTHORIZED_EVENT = 'muddle:unauthorized';
export const SIGNED_OUT_EVENT = 'muddle:signed-out';
